import { FailureScreenProps } from "shared/games/types/GameConfiguration";
import { GameQuestionFaderGrader } from "shared/games/types/GameQuestions";
import { GameAnswerFaderGrader } from "shared/games/types/GameAnswers";
import * as GameLayout from "ui/templates/Game/LayoutComponents";
import Button from "ui/atoms/Button/Button";
import VolumeSelector from "../organisms/VolumeSelector";

type Props = FailureScreenProps<GameQuestionFaderGrader, GameAnswerFaderGrader>;

export default function FaderGraderFailedScreen({
  onNext,
  question,
  mobileToolbarStyle,
}: Props) {
  return (
    <>
      <GameLayout.Toolbar mobileStyle={mobileToolbarStyle}>
        <div className={"flex justify-between"}>
          <div className={"mr-2"} />

          <Button theme="green" size="large" onClick={onNext}>
            Next
          </Button>
        </div>
      </GameLayout.Toolbar>

      <GameLayout.Container>
        <VolumeSelector
          volume={question.volume}
          setVolume={noop}
          playbackState={"failed"}
          question={question}
        />
      </GameLayout.Container>
    </>
  );
}

const noop = () => {};
